module.exports = __webpack_public_path__ + "static/media/loading.fb968027.svg";